// Anonymous funnel tracker — fire-and-forget to /api/funnel/track
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "bc_funnel_sid";

function sid() {
  try {
    let v = sessionStorage.getItem(SID_KEY);
    if (!v) {
      v = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
      sessionStorage.setItem(SID_KEY, v);
    }
    return v;
  } catch (e) {
    return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
}

// Dedupe events (session-scoped) so a scroll_50 or step1_complete fires once per session
function once(event, page) {
  try {
    const k = `bc_funnel_once_${page}_${event}`;
    if (sessionStorage.getItem(k)) return false;
    sessionStorage.setItem(k, "1");
    return true;
  } catch (e) {
    return true;
  }
}

export function trackFunnel(event, page, { meta = null, dedupe = false } = {}) {
  if (dedupe && !once(event, page)) return;
  const payload = { session_id: sid(), event, page, meta };
  try {
    const url = `${API}/funnel/track`;
    const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) return;
    fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true }).catch(() => {});
  } catch (e) { /* swallow */ }
}
